/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MultipleCheckIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Multiple Check',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M29 2H19a1 1 0 00-1 1v5h4a2 2 0 012 2v4h5a1 1 0 001-1V3a1 1 0 00-1-1z" />
    <rect height="12" rx="1" ry="1" width="12" x="2" y="18" />
    <path
      d="M16 18v3.492a12.351 12.351 0 016-5.733V11a1 1 0 00-1-1H11a1 1 0 00-1 1v5h4a2 2 0 012 2zm11.1.2a8.9 8.9 0 108.9 8.9 8.9 8.9 0 00-8.9-8.9zm-2.338 14.312l-4.128-4.128a.5.5 0 010-.707l1.036-1.036a.5.5 0 01.707 0l2.731 2.731 6.106-6.106a.5.5 0 01.707 0l1.043 1.043a.5.5 0 010 .707l-7.5 7.5a.5.5 0 01-.702-.004z"
    />
  </svg>`;
};
